import isNil from 'lodash/isNil';

export const isEmptyItem = ({ _internalListItemId, ...rest }: Record<string, any>) =>
  // _internalListItemId needs to be defined for item selection to work properly
  Object.values(rest).every(propertyValue => isNil(propertyValue)) && _internalListItemId;
